import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

async function enableMocking() {
    if ( (process.env.NODE_ENV !== 'development') || (process.env.REACT_APP_MOCKED !== 'true') ) {
        return;
    }
   
    const { worker } = await import('./mocks/setup');
    return worker.start();
}

enableMocking().then(() => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<BrowserRouter><App /></BrowserRouter>);
});
